/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BookingTerms } from './BookingTerms';
import {
    BookingTermsFromJSON,
    BookingTermsFromJSONTyped,
    BookingTermsToJSON,
    BookingTermsToJSONTyped,
} from './BookingTerms';

/**
 * 
 * @export
 * @interface HoldsCreateMultiDayRequest
 */
export interface HoldsCreateMultiDayRequest {
    /**
     *
     * @type {BookingTerms}
     * @memberof HoldsCreateMultiDayRequest
     */
    bookingTerms?: BookingTerms;
    /**
     *
     * @type {string}
     * @memberof HoldsCreateMultiDayRequest
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof HoldsCreateMultiDayRequest
     */
    stage: string;
    /**
     *
     * @type {Date}
     * @memberof HoldsCreateMultiDayRequest
     */
    startDate: Date;
    /**
     *
     * @type {Date}
     * @memberof HoldsCreateMultiDayRequest
     */
    endDate: Date;
    /**
     *
     * @type {number}
     * @memberof HoldsCreateMultiDayRequest
     */
    promoterTeam: number;
    /**
     *
     * @type {string}
     * @memberof HoldsCreateMultiDayRequest
     */
    notes?: string;
}

/**
 * Check if a given object implements the HoldsCreateMultiDayRequest interface.
 */
export function instanceOfHoldsCreateMultiDayRequest(value: object): value is HoldsCreateMultiDayRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('stage' in value) || value['stage'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('promoterTeam' in value) || value['promoterTeam'] === undefined) return false;
    return true;
}

export function HoldsCreateMultiDayRequestFromJSON(json: any): HoldsCreateMultiDayRequest {
    return HoldsCreateMultiDayRequestFromJSONTyped(json, false);
}

export function HoldsCreateMultiDayRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HoldsCreateMultiDayRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'bookingTerms': json['booking_terms'] == null ? undefined : BookingTermsFromJSON(json['booking_terms']),
        'title': json['title'],
        'stage': json['stage'],
        'startDate': (new Date(json['start_date'])),
        'endDate': (new Date(json['end_date'])),
        'promoterTeam': json['promoter_team'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

  export function HoldsCreateMultiDayRequestToJSON(json: any): HoldsCreateMultiDayRequest {
      return HoldsCreateMultiDayRequestToJSONTyped(json, false);
  }

  export function HoldsCreateMultiDayRequestToJSONTyped(value?: HoldsCreateMultiDayRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking_terms': BookingTermsToJSON(value['bookingTerms']),
        'title': value['title'],
        'stage': value['stage'],
        'start_date': ((value['startDate']).toISOString().substring(0,10)),
        'end_date': ((value['endDate']).toISOString().substring(0,10)),
        'promoter_team': value['promoterTeam'],
        'notes': value['notes'],
    };
}
